import { visitesConstants as vist } from "../../../constants/visites";

const initialState = { loading: true, list: [], data: null, tendances: {} };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case vist.GET_VISITES:
      return {
        ...state,
        loading: false,
        list: payload,
      };
      case vist.GET_TENDANCES:
      return {
        ...state,
        loading: false,
        tendances: payload,
      };
    default:
      return state;
  }
}
